export default "__VITE_PUBLIC_ASSET__3850130d__"